import axios from 'axios';
import {
    submitPayloadDataFailure,
    submitPayloadDataSuccess,
} from '../../../actions/digitalSavings/payloadCollection';

import { getIsApiPending } from '../../../selectors/digitalSavings/documents';
import {
    getAccessToken,
} from '../../../selectors/digitalSavings/payment';
import { getAgentForm } from '../../../selectors/digitalSavings/agentModal';
import { getDocumentsForm } from '../../../selectors/digitalSavings/documents';
import { setExpiredAuth } from '../../../actions/digitalSavings/quote';
import { apiTransitionDocumentsForm } from '../../../actions/digitalSavings/Documents';
import { getQuoteId } from '../../../selectors/digitalSavings/personalDetails';

export const documentsSubmit = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDocumentsForm.pending());
            try {
                const resp = await calculate(store.getState(), action);
                store.dispatch(submitPayloadDataSuccess(resp.data));
                store.dispatch(apiTransitionDocumentsForm.success());
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                    store.dispatch(apiTransitionDocumentsForm.initial());
                } else {
                    store.dispatch(apiTransitionDocumentsForm.failure());
                }
                store.dispatch(submitPayloadDataFailure(e));
                
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state, action) => {
    const documents = getDocumentsForm(state);
    const id = getQuoteId(state);

    const documentsPayload = {
        quoteId: id,
        identificationDoc: documents.idUpload.value?.base64File || "N|A",
        passportDoc: documents.passportUpload.value?.base64File || "N|A",
        kraDoc: documents.kraPinUpload.value?.base64File || null,
    };

    return {
        ...documentsPayload
    };
};

const calculate = async (state, action) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/digital-savings/upload-docs';
        return await axios.post(url, payloadCollection(state, action), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
